import styled from 'styled-components';
import MuiCardMedia from '@mui/material/CardMedia';
import MuiCardContent from '@mui/material/CardContent';
import MuiCard from '@mui/material/Card';
import Image from 'next/image';
import { rgba } from 'polished';
import { Popover } from '@mui/material';
import { makeStyles } from '@mui/styles';
import RoundedButton from '@app/components/atoms/RoundedButton';
import { devices, deviceSizes } from '../../../../config/devices';
import Button from '../../../atoms/Button'

export const CoverImage = styled(Image)`
  position: absolute;
  top: 0;
  left: 0;
`;

export const CoverInfo = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row;
  padding: 5rem 5rem;
  top: 0;
  left: 0;
  color: ${({ theme }) => theme && theme.white};
  width: 100%;
  height: 100%;
  ${({ theme }) =>
    theme &&
    `
    background-color:${rgba(theme.common.black, 0.35)};
    `}
  background: linear-gradient(180deg, rgba(33, 33, 33, 0) 0%, rgba(49, 47, 47, 0.75) 100%), rgba(33, 33, 33, 0.35);
  h1 {
    color: ${({ theme }) => theme && theme.white};
  }

  @media (max-width: ${deviceSizes.mobileL}) {
    padding: 0;
  }

  @media ${devices.sm} {
    padding: 2rem;
  }

  @media ${devices.xs} {
    padding: 0;
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  padding-top: 3rem;
  width: 30%;
`;

export const InfoContainer = styled.div`
  display: flex;
  //flex-grow: 1;
`;

export const ButtonContainer = styled.div`
  display: flex;
  position: absolute;
  top: 1rem;
  right: 0;
`;

export const ApplyButton = styled(RoundedButton)`
  background-color: white;
  color: ${({ theme }) => theme.primaryColor[600]};
  width: 230px;
  :hover {
    background-color: ${({ theme }) => theme.primaryColor[25]};
    //color: white;
  }
`

export const CardContent = styled(MuiCardContent)`
  display: flex;
  /* flex-basis: 75%; */

  @media ${devices.md} {
    /* flex-basis: 65%; */
  }
  @media ${devices.xs} {
    margin-top: 25px;
    padding-bottom : 30px;
    /* flex-basis: 100%; */
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: space-between;
  flex-basis: 100%;
  svg {
    margin-right: 10px;
    font-size: 20px;
  }
`;

export const Card = styled(MuiCard)`
  && {
    position: relative;
    /* border-radius: 13px; */
    display: flex;
    height: 30rem;
    width: 100%;
    @media ${devices.sm} {
      flex-direction: column-reverse;
      height: 25rem;
    }
  }
`;

export const CardMedia = styled(MuiCardMedia)`
  /* height: 15.625rem; */
  display: flex;
  height: 100%;
  /* flex-basis: 25%; */
  @media ${devices.md} {
    /* flex-basis: 35%; */
  }
  @media ${devices.sm} {
    /* flex-basis: 100%; */
    height: 15.625rem;
  }
`;

export const Statistics = styled.div`
  /* justify-content: flex-start; */
  /* display: flex;
  justify-content: space-between; */
  span {
    display: flex;
    align-items: flex-end;
  }
`;
export const ShareButton = styled(Button)`
  && {
    background-color: white;
    margin-top: 10px;

    & :hover {
      background-color: white;
      border: 1px solit ${({ theme }) => theme.red[800]};
      color: ${({ theme }) => theme.red[800]};
    }
  }
`;

export const useClasses = makeStyles({
  lightGray: {
    color: 'white',
    marginBottom: '5px;',
  },
  Allarm: {
    color: '#FFABAB',
    marginBottom: '5px;',
  },

});

export const StyledPopover = styled(Popover)`
  && {
    .MuiPopover-paper {
      box-shadow: none;
      // background-color: inherit;
    }
    svg{
      margin: 0 10px;
    }
  }
`;

export const CopyCliboard = styled.div`
 display: flex;
 align-items: center;
svg{
  cursor: pointer;
}

`
